import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import DataLayer from 'shared/containers/DataLayerContainer';
import UniversalVariable from 'shared/containers/UniversalVariableContainer';

const US_LOCALE = 'en-US';

const Meta = props => {
  const {
    canonicalUrl,
    dataLayerReducer,
    description,
    pageServerAndPort,
    pageType,
    pathname,
    schemas,
    title,
    doNotIndex,
    hideCanonicalTag,
    query,
    selectedLocale,
  } = props;

  const url = canonicalUrl || `${pageServerAndPort}${pathname}`;

  const meta = [];
  if (description) {
    meta.push({ name: 'description', content: description });
  }

  // If the query string contains anything other than page={page} then the url should not be indexed
  if (doNotIndex || Object.keys(query).filter(item => item !== 'page').length) {
    meta.push({ name: 'robots', content: 'noindex, follow' });
  }
  const script = schemas.map(s => ({
    type: 'application/ld+json',
    innerHTML: JSON.stringify({
      '@context': 'http://schema.org',
      ...s,
    }),
  }));

  const titleTemplatePostfix = selectedLocale === US_LOCALE ? ' US' : '';
  const helmetProps = {
    meta,
    script,
    // titleTemplate is only used if there is a title in props. If there is no title then defaultTitle is used instead.
    titleTemplate:
      title &&
      (title.includes('Bravissimo')
        ? ''
        : `%s | Bravissimo${titleTemplatePostfix}`),
    defaultTitle: props.defaultTitle,
  };

  if (title && title.length) {
    helmetProps.title = title;
  }

  if (!hideCanonicalTag) {
    helmetProps.link = [{ rel: 'canonical', href: url }];
  }
  return (
    <div>
      <Helmet {...helmetProps} />
      <DataLayer pageType={pageType} dataLayerReducer={dataLayerReducer} />
      <UniversalVariable pageType={pageType} />
      {props.children}
    </div>
  );
};

Meta.propTypes = {
  basePath: PropTypes.string,
  locales: PropTypes.array,
  children: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  pageType: PropTypes.string,
  dataLayerReducer: PropTypes.func,
  schemas: PropTypes.arrayOf(PropTypes.object),
  pageServerAndPort: PropTypes.string,
  pathname: PropTypes.string,
  canonicalUrl: PropTypes.string,
  doNotIndex: PropTypes.bool,
  hideCanonicalTag: PropTypes.bool,
  defaultTitle: PropTypes.string,
  selectedLocale: PropTypes.string,
  query: PropTypes.object,
};

Meta.defaultProps = {
  schemas: [],
  hideCanonicalTag: false,
  query: {},
};

const mapStateToProps = state => ({
  basePath: state.app.config.basePath,
  locales: state.app.locale.available,
  selectedLocale: state.app.locale.selected,
  pageServerAndPort: state.app.serverAndPort,
  defaultTitle: state.app.meta.defaultTitle,
  pathname: state.app.routing.pathname,
  query: state.app.routing.query,
});

export default connect(mapStateToProps)(Meta);
